export const ProductZoom = (function () {
    "use strict";

    let $productZoomIcon, $productZoomImage, $productZoomThumbnails;

    function init() {
        $productZoomIcon = $(".product .zoom-icon");
        $productZoomImage = $("#product-zoom__image");
        $productZoomThumbnails = $("#product-zoom__thumbnails");

        $productZoomIcon.click(function () {
            let $product = $(this).closest(".product");
            let $featuredImage = $product.find(".main-image");
            let $secondaryImage = $product.find(".secondary-image");
            let $featuredImageHtml;
            let $secondaryImageHtml;

            if ($featuredImage.length) {
                $featuredImageHtml = $featuredImage.html();
                $productZoomImage.html($featuredImageHtml);

                if ($secondaryImage.length) {
                    $secondaryImageHtml = $secondaryImage.html();
                    $productZoomThumbnails.html($secondaryImageHtml).show();
                    $productZoomThumbnails.off().on("click", swapImages);
                } else {
                    $productZoomThumbnails.hide();
                }

                MicroModal.show("product-zoom", {
                    onClose: (modal) => {
                        history.replaceState(null, null, " ");
                    },
                });
            }
        });
    }

    function swapImages(e) {
        let $img2Container = $(this),
            $img2 = $productZoomThumbnails.html(),
            $img1Container = $productZoomImage,
            $img1 = $img1Container.html();

        $img2Container.html($img1);
        $img1Container.html($img2);
    }

    return {
        init: init,
    };
})();
